import React from "react";
import {Box,
    Flex,
    Heading,
    HStack,
    Link,
    IconButton,
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
    useDisclosure,
    useColorModeValue,
    VStack,
    Tabs, 
    TabList, 
    TabPanels, 
    Image, 
    TabPanel} from "@chakra-ui/react";
import { HamburgerIcon, BellIcon } from '@chakra-ui/icons';
import Exclusiveforyou from "./Exclusiveforyou";
import Mydevice from "./Mydevice";
import { useSearchParams } from "react-router-dom";


function App() {

    const [searchParams, setSearchParams] = useSearchParams(window.location.hash);
    const param = searchParams.get('SSOID');
    if (param) {
        localStorage.setItem('ssoid',param)
    }
    const background = {
        /*backgroundImage:`url(${process.env.PUBLIC_URL+ "/background/background1.png"})`,*/
        backgroundImage:`url(${process.env.PUBLIC_URL+ "/banner/ServiceComingsoon.png"})`,
                height:'100vh',
                fontSize:'50px',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                };
    let textColor = useColorModeValue("#565E6D");
                
    return (
        <>
        <Flex alignItems='center' justifyContent={'space-around'} flexDirection='row'>
            <Box w='90%' pt={10}>
                <Image className="d-block w-100" src="/banner/ServiceComingsoon.png" />
            </Box>
                    
        </Flex>
         
        </>
    );
}

export default App;

{/*<div style={background} >
            <Box w='100%' px={4}>
                <Flex h={14} alignItems={'center'} justifyContent={'center'}>
                {/*<Heading color={textColor} fontSize='20px' fontWeight='700' textAlign='center' mb={'20px'}>Smart Life</Heading>*/}
                    {/* <IconButton
                        size={'md'}
                        icon={<HamburgerIcon />}
                        aria-label={'Open Menu'}
                        display={{ md: 'none' }}
                    />*/}
                {/*<HStack spacing={8} alignItems={'center'}>
                    <Box alignItems={'center'}>Services</Box>
                    <HStack
                    as={'nav'}
                    spacing={4}
                    display={{ base: 'none', md: 'flex' }}>
                    </HStack>
                </HStack>/*}
                {/*<Flex alignItems={'center'}>
                    <IconButton
                            size={'md'}
                            icon={<BellIcon />}
                            aria-label={'Bell Menu'}
                            display={{ md: 'none' }}
                        />
    </Flex>*/}
               /* </Flex>
            </Box>
            
            
            <Exclusiveforyou />
            {/*<Tabs align="center" colorScheme='red'>
                <TabList>
                    <Tab>Exclusive for you</Tab>
                    {/* <Tab>My Device</Tab> 
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <Exclusiveforyou />
                    </TabPanel>
                    {/* <TabPanel>
                        <Mydevice />
                    </TabPanel> 
                </TabPanels>
            </Tabs>*/
       /* </div> */